import { useEffect, useState } from "react";
import { clearMessage } from "../../zustand-store/toastMessages-store/actions";
import { CloseIcon, ErrorIcon, SuccessIcon } from "../svg";
import styles from "./style.module.scss";
import cn from "classnames";

export const ToastMessage = ({ message, status }) => {
  const [isToastVisible, setIsToastVisible] = useState(false);
  const location = window.location?.pathname.split("/")[1];
  const handleToast = () => {
    clearMessage();
  };

  useEffect(() => {
    if (!isToastVisible) {
      const timeout = setTimeout(() => {
        clearMessage();
      }, 6000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [message, isToastVisible]);
  return (
    <>
      {message?.length && (
        <section
          // className={styles.notificationShow}
          className={cn(
            styles.notificationShow,
            location === "examination-room"
              ? styles.bottomNotification
              : styles.topNotification
          )}
          onMouseOver={() => {
            setIsToastVisible(true);
          }}
          onMouseLeave={() => {
            setIsToastVisible(false);
            clearMessage();
          }}
        >
          <div className={styles.notification}>
            <div className={styles.notificationHeader}>
              <div className={styles.title}>
                <span className={styles.image}>
                  {status ? <SuccessIcon /> : <ErrorIcon />}
                </span>
                <p className={styles.message}>{message}</p>
              </div>
              <CloseIcon
                width="25"
                height="25"
                fillColor={status ? "#02BF90" : "#B11313"}
                handleClick={() => handleToast()}
                customClass={styles.closeIcon}
              />
            </div>
          </div>
        </section>
      )}
    </>
  );
};
